import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTranslation } from '@/hooks/useTranslation';

export default function DiscoveryKeyboardActions({ onExplore, onDone }) {
  const { t } = useTranslation();
  return <View style={styles.row} testID="discovery-keyboard-actions">
    <Pressable accessibilityRole="button" accessibilityLabel="For you" accessibilityHint="Dismisses the keyboard and returns to your ideas" onPress={onExplore} style={styles.action}>
      <Icon name="arrow-down" size={14} />
      <Text size="s" color="secondary">For you</Text>
    </Pressable>
    <Pressable accessibilityRole="button" onPress={onDone} style={styles.action}>
      <Text size="s" weight="medium">{t('common.done')}</Text>
    </Pressable>
  </View>;
}
const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingHorizontal: 15 },
  action: { minHeight: 44, paddingHorizontal: 10, flexDirection: 'row', alignItems: 'center', gap: 6 },
});
